import React, { ChangeEvent, FormEvent, useState } from 'react'
import { Link } from 'react-router-dom';

import ButtonGroup from 'UI/ButtonGroup';

const ServiceSelector = {
    buttons: [
        {
            value: "negatives",
            label: "Негативы",
        },
        {
            value: "slides",
            label: "Слайды",
        },
        {
            value: "video",
            label: "Видеокассеты",
        },
    ],
    name: "service-selector",
}

const TransferMethodSelector = {
    buttons: [
        {
            value: "courier",
            label: "Курьер на адрес",

        },
        {
            value: "post",
            label: "Отправить почтой",
        },
        {
            value: "in-person",
            label: "Передать лично",
        },
    ],
    name: "transfer-method",
}

const SERVICE_LABELS: Record<string, string> = {
    negatives: "Негативы",
    slides: "Слайды",
    video: "Видеокассеты",
}

const TRANSFER_LABELS: Record<string, string> = {
    courier: "Курьер на адрес",
    post: "Отправить почтой",
    "in-person": "Передать лично",
}

const TELEGRAM_BOT_USERNAME = "dolika_chat_bot";

const CreateOrder = () => {
    const [state, setState] = useState({
        service: "negatives",
        quality: "600",
        transfer: "in-person",
        consentGiven: false,
    })

    function buildTelegramMessage(): string {
        const lines = [
            "Новый заказ:",
            `Услуга: ${SERVICE_LABELS[state.service] ?? state.service}`,
        ];

        if (state.service !== "video") {
            lines.push(`Качество: ${state.quality} dpi`);
        }

        lines.push(`Способ передачи: ${TRANSFER_LABELS[state.transfer] ?? state.transfer}`);

        return lines.join("\n");
    }

    function onSubmit(e: FormEvent) {
        e.preventDefault();

        const text = buildTelegramMessage();
        const telegramUrl = `https://t.me/${TELEGRAM_BOT_USERNAME}?text=${encodeURIComponent(text)}`;

        window.location.href = telegramUrl;
    }

    function onDpiChange(e: ChangeEvent<HTMLSelectElement>) {
        setState({
            ...state,
            quality: e.target.value,
        })
    }

    function onServiceChange(e: ChangeEvent<HTMLInputElement>) {
        setState({
            ...state,
            service: e.target.value,
        })
    }

    function onTransferChange(e: ChangeEvent<HTMLInputElement>) {
        setState({
            ...state,
            transfer: e.target.value,
        })
    }

    function onConsentChange(e: ChangeEvent<HTMLInputElement>) {
        setState({
            ...state,
            consentGiven: e.target.checked,
        })
    }

    return (
        <div className="content fix-width create-order-content">
            <h1>Оформление заказа</h1>
            <form onSubmit={onSubmit}>
                <h3><label htmlFor="service-selector">Выберите услугу</label></h3>
                <ButtonGroup
                    buttons={ServiceSelector.buttons}
                    name={ServiceSelector.name}
                    value={state.service}
                    onChange={onServiceChange}
                />
                {state.service == "video" ? null : <h3><label htmlFor="dpi-selector">Выберите качество</label></h3>}
                {state.service == "video" ? null :
                    <select id="dpi-selector" name="dpi-selector" onChange={onDpiChange} value={state.quality}>
                        <option label="300 dpi" value="300">300</option>
                        <option label="600 dpi" value="600">600</option>
                        <option label="1200 dpi" value="1200">1200</option>
                        <option label="2400 dpi" value="2400">2400</option>
                        <option label="3600 dpi" value="3600">3600</option>
                        <option label="7200 dpi" value="7200">7200</option>
                    </select>
                }
                <h3><label htmlFor="transfer-method">Способ передачи плёнки</label></h3>
                <ButtonGroup
                    buttons={TransferMethodSelector.buttons}
                    name={TransferMethodSelector.name}
                    value={state.transfer}
                    onChange={onTransferChange}
                />

                <label htmlFor="consent-checkbox">
                    <input
                        type="checkbox"
                        name="consent-checkbox"
                        id="consent-checkbox"
                        checked={state.consentGiven}
                        onChange={onConsentChange}
                        required
                    />
                    &nbsp;Я согласен(на) на обработку персональных данных в соответствии с {' '}
                    <Link to="/privacy" target="_blank" rel="noopener noreferrer">
                        Политикой обработки персональных данных
                    </Link>
                </label>
                <br />
                <input
                    type="submit"
                    value="Оформить заказ"
                    className="button button-primary"
                    disabled={!state.consentGiven}
                />
            </form>
        </div>
    );
}

export default CreateOrder;
